import React, { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react';
import s from './Button.module.scss';
import csx from 'classnames';

type BaseProps = {
  classes?: string;
  variant?: 'contained' | 'outlined' | 'text' | 'link';
  color?: 'secondary' | 'primary';
  startIcon?: JSX.Element;
  endIcon?: JSX.Element;
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large';
  title: string | JSX.Element;
  href?: string;
  rel?: string;
  isActive?: boolean;
};

type Button = BaseProps &
  Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'title'>;
type Anchor = BaseProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'title'>;

const Button = React.forwardRef(function ButtonComponent(
  {
    startIcon,
    endIcon,
    title,
    color = 'primary',
    variant = 'contained',
    size = 'medium',
    classes = '',
    onClick,
    href,
    isActive,
    fullWidth,
    ...props
  }: Button | Anchor,
  ref
) {
  const classNames = csx(s.host, s[variant], s[color], s[size], classes, {
    [s.active]: !!isActive,
    [s.fullWidth]: !!fullWidth,
  });

  return React.createElement(
    href ? 'a' : 'button',
    { className: classNames, href, onClick, ref, ...props },
    <span className={s.inner}>
      {!!startIcon && <span className={s.startIcon}>{startIcon}</span>}
      <span className={s.label}>{title}</span>
      {!!endIcon && <span className={s.endIcon}>{endIcon}</span>}
    </span>
  );
});

export default Button;
